"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSupplyMeterInfo = exports.mapRegisters = exports.filterRegistersByMPXN = void 0;
var date_fns_1 = require("date-fns");
var supplies_1 = require("../../../../../shared/core/utils/supplies");
var utils_1 = require("../../../utils");
var _1 = require(".");
var filterRegistersByMPXN = function (supplyRegisterInfo, supplyMPXN) {
    return supplyRegisterInfo.filter(function (_a) {
        var mpxn = _a.mpxn;
        return mpxn === supplyMPXN;
    });
};
exports.filterRegistersByMPXN = filterRegistersByMPXN;
var mapRegisters = function (supply, supplyRegisterInfo) {
    var _a, _b;
    return supply.fuel === 'Electricity'
        ? // If there is kapi info and a legacy supply mpxn use kapi data, otherwise use legacy.
            supplyRegisterInfo && supply.mpxn
                ? (0, exports.filterRegistersByMPXN)(supplyRegisterInfo, supply.mpxn)
                : (_b = (_a = supply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.registers) === null || _b === void 0 ? void 0 : _b.map(function (_a) {
                    var timeOfUseLabel = _a.timeOfUseLabel;
                    return ({
                        timingCategory: timeOfUseLabel
                            ? (0, utils_1.timeOfUseLabelToTimingCategory)(timeOfUseLabel)
                            : null,
                    });
                })
        : undefined;
};
exports.mapRegisters = mapRegisters;
var getSupplyMeterInfo = function (readings, supply, supplyRegisterInfo) {
    var _a, _b, _c, _d, _e;
    var isSmart = (0, _1.isSmartSupply)(supply);
    var isSupplyPointInfoValid = !!supply.supplyPointInfo && !!supply.supplyPointInfo.msn;
    var result = {
        start: supply.start,
        msn: (_b = (_a = supply.supplyPointInfo) === null || _a === void 0 ? void 0 : _a.msn) !== null && _b !== void 0 ? _b : undefined,
        isSupplyPointInfoValid: isSupplyPointInfoValid,
        mpxn: (_c = supply.mpxn) !== null && _c !== void 0 ? _c : null,
        isActive: supply.end ? (0, date_fns_1.isAfter)(supply.end, (0, date_fns_1.endOfToday)()) : true,
        isSmart: isSmart,
        isNonComms: (0, _1.isNonComms)(isSmart, readings),
        isMultiRate: (0, utils_1.isSupplyMultirate)(supply),
        isOnboarding: supply.isOnboarding,
        isInOMRWindow: (0, supplies_1.getOMRWindowStatus)(supply.start).isDuringWindow,
        meterNumOfDigits: ((_d = supply.supplyPointInfo) === null || _d === void 0 ? void 0 : _d.meterNoOfDigitsOrDials) || undefined,
        rawMeterType: ((_e = supply.supplyPointInfo) === null || _e === void 0 ? void 0 : _e.meterType) || undefined,
        registers: (0, exports.mapRegisters)(supply, supplyRegisterInfo),
    };
    return result;
};
exports.getSupplyMeterInfo = getSupplyMeterInfo;
